export const translations = {
    SPONSOR_RESEND_EMAIL: {
        description: 'Sponsor resend email text',
        primaryValue: 'Resend Email',
        stringKey: 'SPONSOR_RESEND_EMAIL',
    },
    SPONSOR_RESEND: {
        description: 'Sponsor resend text',
        primaryValue: 'Resend',
        stringKey: 'SPONSOR_RESEND',
    },
}